<template>
    <aside class="comment__reactions">
        <transition name="fade">
            <nav v-if="visible" class="reaction-picker">
                <a v-for="emoji in availableEmojis"
                   :key="emoji"
                   @click.prevent="react(emoji)"
                   data-locator="emoji"
                   href="#"
                   class="reaction-picker__emoji"
                   :class="{ 'reaction-picker__emoji--disabled' : hasReacted(emoji) }">
                    <emoji :size="24" :emoji="emoji"></emoji>
                </a>
            </nav>
        </transition>
        <div class="reactions">
            <reaction
                    v-for="(reactions, emoji) in groupedReactions"
                    :key="emoji"
                    data-locator="reaction"
                    :emoji="emoji"
                    :reactions="reactions"
                    :comment-id="commentId"
            >
            </reaction>
        </div>
    </aside>
</template>

<script>
import {mapState} from 'vuex'
import {Emoji} from 'emoji-mart-vue'
import Reaction from './Reaction'

export default {
    props: {
        reactions: {
            required: true,
            type: Array,
        },

        commentId: {
            required: true,
            type: Number
        }
    },

    data() {
        return {
            visible: false,
            availableEmojis: app.config.AVAILABLE_REACTIONS,
        }
    },

    created() {
        EventBus.$on('AppClick', (event) => {
            if (!this.$el.contains(event.target)) {
                this.visible = false
            }
        });
    },

    methods: {
        toggle() {
            this.visible = !this.visible
        },

        findUserReaction (type) {
            return this.reactions.find(reaction => reaction.user_id === this.current.id && reaction.type === type)
        },

        hasReacted (type) {
            return this.findUserReaction(type) !== undefined
        },

        react (type) {
            this.visible = false

            this.hasReacted(type)
                ? this.$store.dispatch('job/removeReaction', this.findUserReaction(type))
                : this.$store.dispatch('job/addReaction', {
                    commentId: this.commentId,
                    type
                })
        }
    },

    computed: {
        ...mapState('users', {
            current: 'current'
        }),
        ...mapState('job', {
            job: 'job'
        }),

        groupedReactions() {
            let group = {}

            this.reactions.forEach(reaction => {
                if (group[reaction.type] === undefined) {
                    group[reaction.type] = []
                }

                group[reaction.type].push(reaction)
            })

            return group
        }
    },

    components: {
        Emoji,
        Reaction
    }
}
</script>